<template>
    <div class="flex-grow-1" :class="{ card: showHeaders }">
        <div class="card-header" v-show="panel.chat_info_panel_header && showHeaders">
            <h5 class="mb-0 panel-header">{{ panel.chat_info_panel_header }}</h5>
        </div>
        <div class="d-flex flex-column global-theme-text" :class="{ 'card-body panel-card-body': showHeaders }">
            <div class="row">
                <div v-show="subheaderIsConfigured && showHeaders" class="col-12 mb-2">
                    <div class="rich-text-content mb-2" v-show="subheaderIsConfigured" v-html="panel.sub_header"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div
                        v-for="intent in panel.chat_intents"
                        :key="intent.id"
                        class="alert discovered-item mb-2 border-0"
                        :class="{
                            'alert-success': Boolean(intent.message) && intent.correct === true,
                            'alert-info': Boolean(intent.message) && [null, undefined].includes(intent.correct),
                            'alert-danger': Boolean(intent.message) && intent.correct === false,
                            'alert-gray text-secondary bg-light': Boolean(intent.message) && intent.was_missed,
                            'alert-secondary': !Boolean(intent.message),
                            'd-none': intent.correct !== true && !Boolean(intent.message),
                        }"
                    >
                        <template v-if="intent.message">
                            <div>
                                <span
                                    v-if="intent.correct === true"
                                    class="icon icon-glyphicons-basic-circle-empty-check align-middle mr-1"
                                ></span>
                                <span
                                    v-else-if="intent.correct === false"
                                    class="icon icon-glyphicons-basic-circle-empty-remove align-middle mr-1"
                                ></span>
                                <span
                                    v-else-if="intent.was_missed === true"
                                    class="icon text-danger icon-glyphicons-basic-circle-empty-alert align-middle mr-1"
                                ></span>
                                <span class="align-middle" style="padding-left: 1px">{{ intent.message }}</span>
                            </div>
                            <div v-if="intent.feedback_message">
                                <span class="text-secondary small">
                                    {{ intent.feedback_message }}
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChatInfoPanel",
    props: {
        panel: {
            type: Object,
            required: true,
        },
        savedResponses: {
            type: Array,
            required: false,
        },
        reviewMode: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        subheaderIsConfigured() {
            return this.panel.sub_header !== "" && this.panel.sub_header != "<p></p>"
        },
        // Controls the display of headers - depends on whether the panel is being displayed in
        // review mode.
        showHeaders() {
            return !this.reviewMode
        },
    },
    mounted() {
        if (this.savedResponses) {
            let vm = this
            this.savedResponses.forEach((intentDiscovered) => {
                let panelIntent = vm.panel.chat_intents.find(
                    (panelIntent) => panelIntent.id == intentDiscovered.chat_agent_intent.id
                )
                if (panelIntent) {
                    // Set the feedback message and correctness on the intent.
                    vm.$set(panelIntent, "message", intentDiscovered.message)
                    vm.$set(panelIntent, "correct", intentDiscovered.correct)
                    vm.$set(panelIntent, "was_missed", intentDiscovered.was_missed)
                    vm.$set(panelIntent, "feedback_message", intentDiscovered.chat_agent_intent.feedback_message)
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.discovered-item {
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 10px;
    padding-right: 10px;
}
</style>